import axios from 'axios'

import {
  LOW_INVENTORY_REQUEST,
  LOW_INVENTORY_SUCCESS,
  LOW_INVENTORY_FAIL,
  SALES_REPORT_REQUEST,
  SALES_REPORT_SUCCESS,
  SALES_REPORT_FAIL,
  SALES_LIST_REQUEST,
  SALES_LIST_SUCCESS,
  SALES_LIST_FAIL,
  STOCK_MOVEMENTS_REQUEST,
  STOCK_MOVEMENTS_SUCCESS,
  STOCK_MOVEMENTS_FAIL
} from '../constants/reportConstants'

import { API_URL } from '../apiUrl.js'

export const getLowInventory =
  (lowpageNumber = '') =>
  async (dispatch) => {
    axios.defaults.withCredentials = true

    try {
      dispatch({
        type: LOW_INVENTORY_REQUEST
      })

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      const { data } = await axios.get(`${API_URL}/reports/lowinventory`, {
        ...config,
        params: { lowpageNumber }
      })

      dispatch({
        type: LOW_INVENTORY_SUCCESS,
        payload: data
      })
    } catch (error) {
      dispatch({
        type: LOW_INVENTORY_FAIL,
        payload:
          error.response && error.response.data.message ?
            error.response.data.message
          : error.message
      })
    }
  }

export const getSalesReport =
  ({ from = '', to = '', group = 'day' } = {}) =>
  async (dispatch) => {
    axios.defaults.withCredentials = true

    try {
      dispatch({ type: SALES_REPORT_REQUEST })

      const { data } = await axios.get(`${API_URL}/reports/sales`, {
        params: { from, to, group, tz: new Date().getTimezoneOffset() }
      })

      dispatch({ type: SALES_REPORT_SUCCESS, payload: data })
    } catch (error) {
      dispatch({
        type: SALES_REPORT_FAIL,
        payload:
          error.response && error.response.data.message ?
            error.response.data.message
          : error.message
      })
    }
  }

const errorText = (error) =>
  error.response && error.response.data.message ?
    error.response.data.message
  : error.message

export const getSalesList =
  ({ from = '', to = '', pageNumber = 1 } = {}) =>
  async (dispatch) => {
    axios.defaults.withCredentials = true

    try {
      dispatch({ type: SALES_LIST_REQUEST })

      const { data } = await axios.get(`${API_URL}/reports/sales/list`, {
        params: { from, to, pageNumber, tz: new Date().getTimezoneOffset() }
      })

      dispatch({ type: SALES_LIST_SUCCESS, payload: data })
    } catch (error) {
      dispatch({ type: SALES_LIST_FAIL, payload: errorText(error) })
    }
  }

export const getStockMovements =
  ({ from = '', to = '', type = '', keyword = '', pageNumber = 1 } = {}) =>
  async (dispatch) => {
    axios.defaults.withCredentials = true

    try {
      dispatch({ type: STOCK_MOVEMENTS_REQUEST })

      const { data } = await axios.get(`${API_URL}/reports/stockmovements`, {
        params: {
          from,
          to,
          type,
          keyword,
          pageNumber,
          tz: new Date().getTimezoneOffset()
        }
      })

      dispatch({ type: STOCK_MOVEMENTS_SUCCESS, payload: data })
    } catch (error) {
      dispatch({ type: STOCK_MOVEMENTS_FAIL, payload: errorText(error) })
    }
  }
